/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddNftGroupingBody,
  AddNftTrackerBody,
  ApiError,
  BurnNftRewardBody,
  CreateDevourLootboxNftRewardsBatchBody,
  CreateDevourLootboxNftRewardsBatchResponse,
  EVMChain,
  ForceUpdateNftOwnershipBody,
  ForceUpdateNftOwnershipResponse,
  GetMyEntryTokensResponse,
  GetNftGroupingResponse,
  GetNftGroupingsResponse,
  GetNftGroupingsSort,
  GetNftMintTransactionsResponse,
  GetNftMintTransactionsSort,
  GetNftOwnershipsResponse,
  GetNftRewardPrizesForAdminResponse,
  GetNftRewardResponse,
  GetNftTrackerResponse,
  GetNftTrackersFromGroupingResponse,
  GetNftTrackersResponse,
  GetNftTrackersSort,
  GetUserRedeemableNftOwnershipsResponse,
  LootboxReward,
  NftMetadata,
  NftTrackersMetadataBatchBody,
  NftTrackersMetadataBatchResponse,
  NftType,
  RedeemNftRewardBody,
  RedeemNftRewardResponse,
  RedeemXpMultiplierBody,
  RefreshNftMetadataBody,
  RefreshNftMetadataResponse,
  SortOrder,
  UpdateNftGroupingBody,
  UpdateNftRewardPrizeBody,
  UpsertNftRewardBody,
  XpMultiplier,
} from '../models/index';
import {
    AddNftGroupingBodyFromJSON,
    AddNftGroupingBodyToJSON,
    AddNftTrackerBodyFromJSON,
    AddNftTrackerBodyToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    BurnNftRewardBodyFromJSON,
    BurnNftRewardBodyToJSON,
    CreateDevourLootboxNftRewardsBatchBodyFromJSON,
    CreateDevourLootboxNftRewardsBatchBodyToJSON,
    CreateDevourLootboxNftRewardsBatchResponseFromJSON,
    CreateDevourLootboxNftRewardsBatchResponseToJSON,
    EVMChainFromJSON,
    EVMChainToJSON,
    ForceUpdateNftOwnershipBodyFromJSON,
    ForceUpdateNftOwnershipBodyToJSON,
    ForceUpdateNftOwnershipResponseFromJSON,
    ForceUpdateNftOwnershipResponseToJSON,
    GetMyEntryTokensResponseFromJSON,
    GetMyEntryTokensResponseToJSON,
    GetNftGroupingResponseFromJSON,
    GetNftGroupingResponseToJSON,
    GetNftGroupingsResponseFromJSON,
    GetNftGroupingsResponseToJSON,
    GetNftGroupingsSortFromJSON,
    GetNftGroupingsSortToJSON,
    GetNftMintTransactionsResponseFromJSON,
    GetNftMintTransactionsResponseToJSON,
    GetNftMintTransactionsSortFromJSON,
    GetNftMintTransactionsSortToJSON,
    GetNftOwnershipsResponseFromJSON,
    GetNftOwnershipsResponseToJSON,
    GetNftRewardPrizesForAdminResponseFromJSON,
    GetNftRewardPrizesForAdminResponseToJSON,
    GetNftRewardResponseFromJSON,
    GetNftRewardResponseToJSON,
    GetNftTrackerResponseFromJSON,
    GetNftTrackerResponseToJSON,
    GetNftTrackersFromGroupingResponseFromJSON,
    GetNftTrackersFromGroupingResponseToJSON,
    GetNftTrackersResponseFromJSON,
    GetNftTrackersResponseToJSON,
    GetNftTrackersSortFromJSON,
    GetNftTrackersSortToJSON,
    GetUserRedeemableNftOwnershipsResponseFromJSON,
    GetUserRedeemableNftOwnershipsResponseToJSON,
    LootboxRewardFromJSON,
    LootboxRewardToJSON,
    NftMetadataFromJSON,
    NftMetadataToJSON,
    NftTrackersMetadataBatchBodyFromJSON,
    NftTrackersMetadataBatchBodyToJSON,
    NftTrackersMetadataBatchResponseFromJSON,
    NftTrackersMetadataBatchResponseToJSON,
    NftTypeFromJSON,
    NftTypeToJSON,
    RedeemNftRewardBodyFromJSON,
    RedeemNftRewardBodyToJSON,
    RedeemNftRewardResponseFromJSON,
    RedeemNftRewardResponseToJSON,
    RedeemXpMultiplierBodyFromJSON,
    RedeemXpMultiplierBodyToJSON,
    RefreshNftMetadataBodyFromJSON,
    RefreshNftMetadataBodyToJSON,
    RefreshNftMetadataResponseFromJSON,
    RefreshNftMetadataResponseToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
    UpdateNftGroupingBodyFromJSON,
    UpdateNftGroupingBodyToJSON,
    UpdateNftRewardPrizeBodyFromJSON,
    UpdateNftRewardPrizeBodyToJSON,
    UpsertNftRewardBodyFromJSON,
    UpsertNftRewardBodyToJSON,
    XpMultiplierFromJSON,
    XpMultiplierToJSON,
} from '../models/index';

export interface CreateBurnNftRewardIdRequest {
    id: string;
    burnNftRewardBody?: BurnNftRewardBody;
}

export interface CreateDevourLootboxNftRewardsBatchRequest {
    createDevourLootboxNftRewardsBatchBody: CreateDevourLootboxNftRewardsBatchBody;
}

export interface CreateNftGroupingsRequest {
    addNftGroupingBody?: AddNftGroupingBody;
}

export interface CreateNftRewardPrizesRequest {
    updateNftRewardPrizeBody?: UpdateNftRewardPrizeBody;
}

export interface CreateNftTrackersRequest {
    addNftTrackerBody?: AddNftTrackerBody;
}

export interface CreateNftTrackersMetadataBatchRequest {
    nftTrackersMetadataBatchBody?: NftTrackersMetadataBatchBody;
}

export interface CreateRedeemNftRewardRequest {
    redeemNftRewardBody?: RedeemNftRewardBody;
}

export interface CreateRedeemXpMultiplierRequest {
    redeemXpMultiplierBody?: RedeemXpMultiplierBody;
}

export interface CreateRefreshNftMetadataRequest {
    refreshNftMetadataBody?: RefreshNftMetadataBody;
}

export interface CreateUpdateNftOwnershipRequest {
    forceUpdateNftOwnershipBody?: ForceUpdateNftOwnershipBody;
}

export interface DeleteNftTrackersIdRequest {
    id: string;
}

export interface GetDevourLootboxNftRewardIdRequest {
    id: string;
}

export interface GetNftGroupingsRequest {
    onlyShowEligible?: string;
    evmChain?: EVMChain;
    categoryId?: string;
    search?: string;
    sort?: GetNftGroupingsSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetNftGroupingsIdRequest {
    id: string;
}

export interface GetNftMintTransactionsRequest {
    evmChain?: EVMChain;
    type?: NftType;
    userId?: string;
    trackerId?: string;
    dateStart?: string;
    dateEnd?: string;
    sort?: GetNftMintTransactionsSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetNftRewardPrizesForAdminRequest {
    search?: string;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetNftTrackerIdRequest {
    id: string;
}

export interface GetNftTrackersRequest {
    evmChain?: EVMChain;
    contractAddress?: string;
    search?: string;
    sort?: GetNftTrackersSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetNftTrackersFromGroupingIdRequest {
    id: string;
}

export interface GetNftTrackersIdMetadataRequest {
    id: string;
}

export interface GetNftTrackersIdRewardRequest {
    id: string;
}

export interface GetValidateEligiblePrizesRemainingIdRequest {
    id: string;
}

export interface UpdateNftGroupingsRequest {
    updateNftGroupingBody?: UpdateNftGroupingBody;
}

export interface UpdateNftGroupsIdRequest {
    id: string;
    body?: object;
}

export interface UpdateNftRewardPrizesIdRequest {
    id: string;
    updateNftRewardPrizeBody?: UpdateNftRewardPrizeBody;
}

export interface UpdateNftRewardsRequest {
    upsertNftRewardBody?: UpsertNftRewardBody;
}

export interface UpdateNftTrackersIdRequest {
    id: string;
    addNftTrackerBody?: AddNftTrackerBody;
}

/**
 * NftsApi - interface
 * 
 * @export
 * @interface NftsApiInterface
 */
export interface NftsApiInterface {
    /**
     * Marks a NFT lootbox as about to be burned.
     * @param {string} id 
     * @param {BurnNftRewardBody} [burnNftRewardBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    createBurnNftRewardIdRaw(requestParameters: CreateBurnNftRewardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Marks a NFT lootbox as about to be burned.
     */
    createBurnNftRewardId(requestParameters: CreateBurnNftRewardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Batch-fetch devour lootbox NFT rewards by tracker IDs. Replaces per-tracker calls to /devour-lootbox-nft-reward/:id when rendering a list of NFT sale configs.
     * @param {CreateDevourLootboxNftRewardsBatchBody} createDevourLootboxNftRewardsBatchBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    createDevourLootboxNftRewardsBatchRaw(requestParameters: CreateDevourLootboxNftRewardsBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDevourLootboxNftRewardsBatchResponse>>;

    /**
     * Batch-fetch devour lootbox NFT rewards by tracker IDs. Replaces per-tracker calls to /devour-lootbox-nft-reward/:id when rendering a list of NFT sale configs.
     */
    createDevourLootboxNftRewardsBatch(requestParameters: CreateDevourLootboxNftRewardsBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDevourLootboxNftRewardsBatchResponse>;

    /**
     * Adds a new nft grouping to the system
     * @param {AddNftGroupingBody} [addNftGroupingBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    createNftGroupingsRaw(requestParameters: CreateNftGroupingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Adds a new nft grouping to the system
     */
    createNftGroupings(requestParameters: CreateNftGroupingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Adds a new prize to the system
     * @param {UpdateNftRewardPrizeBody} [updateNftRewardPrizeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    createNftRewardPrizesRaw(requestParameters: CreateNftRewardPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Adds a new prize to the system
     */
    createNftRewardPrizes(requestParameters: CreateNftRewardPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Adds a new nft tracker to the system
     * @param {AddNftTrackerBody} [addNftTrackerBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    createNftTrackersRaw(requestParameters: CreateNftTrackersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Adds a new nft tracker to the system
     */
    createNftTrackers(requestParameters: CreateNftTrackersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Resolves NFT metadata for many ownership IDs in one request. Replaces the per-tile GET /nft-trackers/{id}/metadata N+1 on inventory pages (DEVOUR-WEB-3P6). DB-only — ownerships whose metadata is not yet materialized are omitted rather than backfilled from Alchemy.
     * @param {NftTrackersMetadataBatchBody} [nftTrackersMetadataBatchBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    createNftTrackersMetadataBatchRaw(requestParameters: CreateNftTrackersMetadataBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NftTrackersMetadataBatchResponse>>;

    /**
     * Resolves NFT metadata for many ownership IDs in one request. Replaces the per-tile GET /nft-trackers/{id}/metadata N+1 on inventory pages (DEVOUR-WEB-3P6). DB-only — ownerships whose metadata is not yet materialized are omitted rather than backfilled from Alchemy.
     */
    createNftTrackersMetadataBatch(requestParameters: CreateNftTrackersMetadataBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NftTrackersMetadataBatchResponse>;

    /**
     * Validates burn transaction hash and returns the prize won by user from redeeming their NFT reward.
     * @param {RedeemNftRewardBody} [redeemNftRewardBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    createRedeemNftRewardRaw(requestParameters: CreateRedeemNftRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RedeemNftRewardResponse>>;

    /**
     * Validates burn transaction hash and returns the prize won by user from redeeming their NFT reward.
     */
    createRedeemNftReward(requestParameters: CreateRedeemNftRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RedeemNftRewardResponse>;

    /**
     * Validates burn transaction hash and returns the XP multiplier for the user.
     * @param {RedeemXpMultiplierBody} [redeemXpMultiplierBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    createRedeemXpMultiplierRaw(requestParameters: CreateRedeemXpMultiplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<XpMultiplier>>;

    /**
     * Validates burn transaction hash and returns the XP multiplier for the user.
     */
    createRedeemXpMultiplier(requestParameters: CreateRedeemXpMultiplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<XpMultiplier>;

    /**
     * Updates all NFT Ownership metadata & images.
     * @param {RefreshNftMetadataBody} [refreshNftMetadataBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    createRefreshNftMetadataRaw(requestParameters: CreateRefreshNftMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RefreshNftMetadataResponse>>;

    /**
     * Updates all NFT Ownership metadata & images.
     */
    createRefreshNftMetadata(requestParameters: CreateRefreshNftMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RefreshNftMetadataResponse>;

    /**
     * Updates all NFT Ownerships in the system with SimpleHash data, creates webhooks if needed.
     * @param {ForceUpdateNftOwnershipBody} [forceUpdateNftOwnershipBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    createUpdateNftOwnershipRaw(requestParameters: CreateUpdateNftOwnershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ForceUpdateNftOwnershipResponse>>;

    /**
     * Updates all NFT Ownerships in the system with SimpleHash data, creates webhooks if needed.
     */
    createUpdateNftOwnership(requestParameters: CreateUpdateNftOwnershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ForceUpdateNftOwnershipResponse>;

    /**
     * Delete a single NFT Tracker along with its associated NFT Ownerships and any simplehash webhooks.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    deleteNftTrackersIdRaw(requestParameters: DeleteNftTrackersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a single NFT Tracker along with its associated NFT Ownerships and any simplehash webhooks.
     */
    deleteNftTrackersId(requestParameters: DeleteNftTrackersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Gets the reward of the devour lootbox.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getDevourLootboxNftRewardIdRaw(requestParameters: GetDevourLootboxNftRewardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftRewardResponse>>;

    /**
     * Gets the reward of the devour lootbox.
     */
    getDevourLootboxNftRewardId(requestParameters: GetDevourLootboxNftRewardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftRewardResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getGetNftOwnershipsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftOwnershipsResponse>>;

    /**
     */
    getGetNftOwnerships(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftOwnershipsResponse>;

    /**
     * Gets all lootbox rewards and their associated prizes.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getLootboxNftRewardsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LootboxReward>>>;

    /**
     * Gets all lootbox rewards and their associated prizes.
     */
    getLootboxNftRewards(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LootboxReward>>;

    /**
     * The authenticated user\'s spendable competition entry tokens, grouped by token type, each with the open competitions that accept it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getMyEntryTokensRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMyEntryTokensResponse>>;

    /**
     * The authenticated user\'s spendable competition entry tokens, grouped by token type, each with the open competitions that accept it.
     */
    getMyEntryTokens(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMyEntryTokensResponse>;

    /**
     * 
     * @param {string} [onlyShowEligible] 
     * @param {EVMChain} [evmChain] 
     * @param {string} [categoryId] 
     * @param {string} [search] 
     * @param {GetNftGroupingsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getNftGroupingsRaw(requestParameters: GetNftGroupingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftGroupingsResponse>>;

    /**
     */
    getNftGroupings(requestParameters: GetNftGroupingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftGroupingsResponse>;

    /**
     * Gets a single Nft Grouping with all of its associated Nft trackers.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getNftGroupingsIdRaw(requestParameters: GetNftGroupingsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftGroupingResponse>>;

    /**
     * Gets a single Nft Grouping with all of its associated Nft trackers.
     */
    getNftGroupingsId(requestParameters: GetNftGroupingsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftGroupingResponse>;

    /**
     * 
     * @param {EVMChain} [evmChain] 
     * @param {NftType} [type] 
     * @param {string} [userId] 
     * @param {string} [trackerId] 
     * @param {string} [dateStart] 
     * @param {string} [dateEnd] 
     * @param {GetNftMintTransactionsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getNftMintTransactionsRaw(requestParameters: GetNftMintTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftMintTransactionsResponse>>;

    /**
     */
    getNftMintTransactions(requestParameters: GetNftMintTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftMintTransactionsResponse>;

    /**
     * 
     * @param {string} [search] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getNftRewardPrizesForAdminRaw(requestParameters: GetNftRewardPrizesForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftRewardPrizesForAdminResponse>>;

    /**
     */
    getNftRewardPrizesForAdmin(requestParameters: GetNftRewardPrizesForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftRewardPrizesForAdminResponse>;

    /**
     * Gets a single Nft Tracker with all of its associated Nft trackers.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getNftTrackerIdRaw(requestParameters: GetNftTrackerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftTrackerResponse>>;

    /**
     * Gets a single Nft Tracker with all of its associated Nft trackers.
     */
    getNftTrackerId(requestParameters: GetNftTrackerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftTrackerResponse>;

    /**
     * 
     * @param {EVMChain} [evmChain] 
     * @param {string} [contractAddress] 
     * @param {string} [search] 
     * @param {GetNftTrackersSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getNftTrackersRaw(requestParameters: GetNftTrackersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftTrackersResponse>>;

    /**
     */
    getNftTrackers(requestParameters: GetNftTrackersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftTrackersResponse>;

    /**
     * Gets all the NFT trackers which belong to a grouping.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getNftTrackersFromGroupingIdRaw(requestParameters: GetNftTrackersFromGroupingIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftTrackersFromGroupingResponse>>;

    /**
     * Gets all the NFT trackers which belong to a grouping.
     */
    getNftTrackersFromGroupingId(requestParameters: GetNftTrackersFromGroupingIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftTrackersFromGroupingResponse>;

    /**
     * Gets a single NFT metadata for the specified ownership.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getNftTrackersIdMetadataRaw(requestParameters: GetNftTrackersIdMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NftMetadata>>;

    /**
     * Gets a single NFT metadata for the specified ownership.
     */
    getNftTrackersIdMetadata(requestParameters: GetNftTrackersIdMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NftMetadata>;

    /**
     * Gets a single reward metadata for the specified tracker and all of its associated prizes.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getNftTrackersIdRewardRaw(requestParameters: GetNftTrackersIdRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftRewardResponse>>;

    /**
     * Gets a single reward metadata for the specified tracker and all of its associated prizes.
     */
    getNftTrackersIdReward(requestParameters: GetNftTrackersIdRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftRewardResponse>;

    /**
     * Get all redeemable NFT ownerships in user\'s Magic Wallet
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getRedeemableNftOwnershipsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserRedeemableNftOwnershipsResponse>>;

    /**
     * Get all redeemable NFT ownerships in user\'s Magic Wallet
     */
    getRedeemableNftOwnerships(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserRedeemableNftOwnershipsResponse>;

    /**
     * Pre-burn validation so that users do not destroy their NFTs when there\'s no eligible prizes remaining.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    getValidateEligiblePrizesRemainingIdRaw(requestParameters: GetValidateEligiblePrizesRemainingIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Pre-burn validation so that users do not destroy their NFTs when there\'s no eligible prizes remaining.
     */
    getValidateEligiblePrizesRemainingId(requestParameters: GetValidateEligiblePrizesRemainingIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Update nft grouping in the system
     * @param {UpdateNftGroupingBody} [updateNftGroupingBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    updateNftGroupingsRaw(requestParameters: UpdateNftGroupingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update nft grouping in the system
     */
    updateNftGroupings(requestParameters: UpdateNftGroupingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Delete a single NFT Grouping\'s associated NFT Trackers & Ownerships, then set it as disabled.
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    updateNftGroupsIdRaw(requestParameters: UpdateNftGroupsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a single NFT Grouping\'s associated NFT Trackers & Ownerships, then set it as disabled.
     */
    updateNftGroupsId(requestParameters: UpdateNftGroupsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Updates an existing NFT reward prize in the system for Admin.
     * @param {string} id 
     * @param {UpdateNftRewardPrizeBody} [updateNftRewardPrizeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    updateNftRewardPrizesIdRaw(requestParameters: UpdateNftRewardPrizesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Updates an existing NFT reward prize in the system for Admin.
     */
    updateNftRewardPrizesId(requestParameters: UpdateNftRewardPrizesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Updates or Creates a NFT reward\'s metadata in the system and add prizes to the reward
     * @param {UpsertNftRewardBody} [upsertNftRewardBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    updateNftRewardsRaw(requestParameters: UpdateNftRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Updates or Creates a NFT reward\'s metadata in the system and add prizes to the reward
     */
    updateNftRewards(requestParameters: UpdateNftRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Updates a nft tracker in the system
     * @param {string} id 
     * @param {AddNftTrackerBody} [addNftTrackerBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NftsApiInterface
     */
    updateNftTrackersIdRaw(requestParameters: UpdateNftTrackersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Updates a nft tracker in the system
     */
    updateNftTrackersId(requestParameters: UpdateNftTrackersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class NftsApi extends runtime.BaseAPI implements NftsApiInterface {

    /**
     * Marks a NFT lootbox as about to be burned.
     */
    async createBurnNftRewardIdRaw(requestParameters: CreateBurnNftRewardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createBurnNftRewardId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/burn-nft-reward/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BurnNftRewardBodyToJSON(requestParameters['burnNftRewardBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Marks a NFT lootbox as about to be burned.
     */
    async createBurnNftRewardId(requestParameters: CreateBurnNftRewardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createBurnNftRewardIdRaw(requestParameters, initOverrides);
    }

    /**
     * Batch-fetch devour lootbox NFT rewards by tracker IDs. Replaces per-tracker calls to /devour-lootbox-nft-reward/:id when rendering a list of NFT sale configs.
     */
    async createDevourLootboxNftRewardsBatchRaw(requestParameters: CreateDevourLootboxNftRewardsBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDevourLootboxNftRewardsBatchResponse>> {
        if (requestParameters['createDevourLootboxNftRewardsBatchBody'] == null) {
            throw new runtime.RequiredError(
                'createDevourLootboxNftRewardsBatchBody',
                'Required parameter "createDevourLootboxNftRewardsBatchBody" was null or undefined when calling createDevourLootboxNftRewardsBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/devour-lootbox-nft-rewards/batch`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDevourLootboxNftRewardsBatchBodyToJSON(requestParameters['createDevourLootboxNftRewardsBatchBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDevourLootboxNftRewardsBatchResponseFromJSON(jsonValue));
    }

    /**
     * Batch-fetch devour lootbox NFT rewards by tracker IDs. Replaces per-tracker calls to /devour-lootbox-nft-reward/:id when rendering a list of NFT sale configs.
     */
    async createDevourLootboxNftRewardsBatch(requestParameters: CreateDevourLootboxNftRewardsBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDevourLootboxNftRewardsBatchResponse> {
        const response = await this.createDevourLootboxNftRewardsBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a new nft grouping to the system
     */
    async createNftGroupingsRaw(requestParameters: CreateNftGroupingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-groupings`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddNftGroupingBodyToJSON(requestParameters['addNftGroupingBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Adds a new nft grouping to the system
     */
    async createNftGroupings(requestParameters: CreateNftGroupingsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createNftGroupingsRaw(requestParameters, initOverrides);
    }

    /**
     * Adds a new prize to the system
     */
    async createNftRewardPrizesRaw(requestParameters: CreateNftRewardPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-reward-prizes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateNftRewardPrizeBodyToJSON(requestParameters['updateNftRewardPrizeBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Adds a new prize to the system
     */
    async createNftRewardPrizes(requestParameters: CreateNftRewardPrizesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createNftRewardPrizesRaw(requestParameters, initOverrides);
    }

    /**
     * Adds a new nft tracker to the system
     */
    async createNftTrackersRaw(requestParameters: CreateNftTrackersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-trackers`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddNftTrackerBodyToJSON(requestParameters['addNftTrackerBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Adds a new nft tracker to the system
     */
    async createNftTrackers(requestParameters: CreateNftTrackersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createNftTrackersRaw(requestParameters, initOverrides);
    }

    /**
     * Resolves NFT metadata for many ownership IDs in one request. Replaces the per-tile GET /nft-trackers/{id}/metadata N+1 on inventory pages (DEVOUR-WEB-3P6). DB-only — ownerships whose metadata is not yet materialized are omitted rather than backfilled from Alchemy.
     */
    async createNftTrackersMetadataBatchRaw(requestParameters: CreateNftTrackersMetadataBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NftTrackersMetadataBatchResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/nft-trackers/metadata/batch`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NftTrackersMetadataBatchBodyToJSON(requestParameters['nftTrackersMetadataBatchBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NftTrackersMetadataBatchResponseFromJSON(jsonValue));
    }

    /**
     * Resolves NFT metadata for many ownership IDs in one request. Replaces the per-tile GET /nft-trackers/{id}/metadata N+1 on inventory pages (DEVOUR-WEB-3P6). DB-only — ownerships whose metadata is not yet materialized are omitted rather than backfilled from Alchemy.
     */
    async createNftTrackersMetadataBatch(requestParameters: CreateNftTrackersMetadataBatchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NftTrackersMetadataBatchResponse> {
        const response = await this.createNftTrackersMetadataBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validates burn transaction hash and returns the prize won by user from redeeming their NFT reward.
     */
    async createRedeemNftRewardRaw(requestParameters: CreateRedeemNftRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RedeemNftRewardResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/redeem-nft-reward`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RedeemNftRewardBodyToJSON(requestParameters['redeemNftRewardBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RedeemNftRewardResponseFromJSON(jsonValue));
    }

    /**
     * Validates burn transaction hash and returns the prize won by user from redeeming their NFT reward.
     */
    async createRedeemNftReward(requestParameters: CreateRedeemNftRewardRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RedeemNftRewardResponse> {
        const response = await this.createRedeemNftRewardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validates burn transaction hash and returns the XP multiplier for the user.
     */
    async createRedeemXpMultiplierRaw(requestParameters: CreateRedeemXpMultiplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<XpMultiplier>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/redeem-xp-multiplier`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RedeemXpMultiplierBodyToJSON(requestParameters['redeemXpMultiplierBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => XpMultiplierFromJSON(jsonValue));
    }

    /**
     * Validates burn transaction hash and returns the XP multiplier for the user.
     */
    async createRedeemXpMultiplier(requestParameters: CreateRedeemXpMultiplierRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<XpMultiplier> {
        const response = await this.createRedeemXpMultiplierRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates all NFT Ownership metadata & images.
     */
    async createRefreshNftMetadataRaw(requestParameters: CreateRefreshNftMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RefreshNftMetadataResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/refresh-nft-metadata`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RefreshNftMetadataBodyToJSON(requestParameters['refreshNftMetadataBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RefreshNftMetadataResponseFromJSON(jsonValue));
    }

    /**
     * Updates all NFT Ownership metadata & images.
     */
    async createRefreshNftMetadata(requestParameters: CreateRefreshNftMetadataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RefreshNftMetadataResponse> {
        const response = await this.createRefreshNftMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates all NFT Ownerships in the system with SimpleHash data, creates webhooks if needed.
     */
    async createUpdateNftOwnershipRaw(requestParameters: CreateUpdateNftOwnershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ForceUpdateNftOwnershipResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/update-nft-ownership`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ForceUpdateNftOwnershipBodyToJSON(requestParameters['forceUpdateNftOwnershipBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ForceUpdateNftOwnershipResponseFromJSON(jsonValue));
    }

    /**
     * Updates all NFT Ownerships in the system with SimpleHash data, creates webhooks if needed.
     */
    async createUpdateNftOwnership(requestParameters: CreateUpdateNftOwnershipRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ForceUpdateNftOwnershipResponse> {
        const response = await this.createUpdateNftOwnershipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a single NFT Tracker along with its associated NFT Ownerships and any simplehash webhooks.
     */
    async deleteNftTrackersIdRaw(requestParameters: DeleteNftTrackersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteNftTrackersId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-trackers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a single NFT Tracker along with its associated NFT Ownerships and any simplehash webhooks.
     */
    async deleteNftTrackersId(requestParameters: DeleteNftTrackersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteNftTrackersIdRaw(requestParameters, initOverrides);
    }

    /**
     * Gets the reward of the devour lootbox.
     */
    async getDevourLootboxNftRewardIdRaw(requestParameters: GetDevourLootboxNftRewardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftRewardResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getDevourLootboxNftRewardId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/devour-lootbox-nft-reward/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNftRewardResponseFromJSON(jsonValue));
    }

    /**
     * Gets the reward of the devour lootbox.
     */
    async getDevourLootboxNftRewardId(requestParameters: GetDevourLootboxNftRewardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftRewardResponse> {
        const response = await this.getDevourLootboxNftRewardIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getGetNftOwnershipsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftOwnershipsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/get-nft-ownerships`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNftOwnershipsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getGetNftOwnerships(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftOwnershipsResponse> {
        const response = await this.getGetNftOwnershipsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets all lootbox rewards and their associated prizes.
     */
    async getLootboxNftRewardsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LootboxReward>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/lootbox-nft-rewards`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LootboxRewardFromJSON));
    }

    /**
     * Gets all lootbox rewards and their associated prizes.
     */
    async getLootboxNftRewards(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LootboxReward>> {
        const response = await this.getLootboxNftRewardsRaw(initOverrides);
        return await response.value();
    }

    /**
     * The authenticated user\'s spendable competition entry tokens, grouped by token type, each with the open competitions that accept it.
     */
    async getMyEntryTokensRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMyEntryTokensResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/my-entry-tokens`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMyEntryTokensResponseFromJSON(jsonValue));
    }

    /**
     * The authenticated user\'s spendable competition entry tokens, grouped by token type, each with the open competitions that accept it.
     */
    async getMyEntryTokens(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMyEntryTokensResponse> {
        const response = await this.getMyEntryTokensRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getNftGroupingsRaw(requestParameters: GetNftGroupingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftGroupingsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['onlyShowEligible'] != null) {
            queryParameters['onlyShowEligible'] = requestParameters['onlyShowEligible'];
        }

        if (requestParameters['evmChain'] != null) {
            queryParameters['evmChain'] = requestParameters['evmChain'];
        }

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-groupings`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNftGroupingsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getNftGroupings(requestParameters: GetNftGroupingsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftGroupingsResponse> {
        const response = await this.getNftGroupingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a single Nft Grouping with all of its associated Nft trackers.
     */
    async getNftGroupingsIdRaw(requestParameters: GetNftGroupingsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftGroupingResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getNftGroupingsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-groupings/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNftGroupingResponseFromJSON(jsonValue));
    }

    /**
     * Gets a single Nft Grouping with all of its associated Nft trackers.
     */
    async getNftGroupingsId(requestParameters: GetNftGroupingsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftGroupingResponse> {
        const response = await this.getNftGroupingsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getNftMintTransactionsRaw(requestParameters: GetNftMintTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftMintTransactionsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['evmChain'] != null) {
            queryParameters['evmChain'] = requestParameters['evmChain'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['trackerId'] != null) {
            queryParameters['trackerId'] = requestParameters['trackerId'];
        }

        if (requestParameters['dateStart'] != null) {
            queryParameters['dateStart'] = requestParameters['dateStart'];
        }

        if (requestParameters['dateEnd'] != null) {
            queryParameters['dateEnd'] = requestParameters['dateEnd'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-mint-transactions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNftMintTransactionsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getNftMintTransactions(requestParameters: GetNftMintTransactionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftMintTransactionsResponse> {
        const response = await this.getNftMintTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getNftRewardPrizesForAdminRaw(requestParameters: GetNftRewardPrizesForAdminRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftRewardPrizesForAdminResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-reward-prizes-for-admin`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNftRewardPrizesForAdminResponseFromJSON(jsonValue));
    }

    /**
     */
    async getNftRewardPrizesForAdmin(requestParameters: GetNftRewardPrizesForAdminRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftRewardPrizesForAdminResponse> {
        const response = await this.getNftRewardPrizesForAdminRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a single Nft Tracker with all of its associated Nft trackers.
     */
    async getNftTrackerIdRaw(requestParameters: GetNftTrackerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftTrackerResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getNftTrackerId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-tracker/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNftTrackerResponseFromJSON(jsonValue));
    }

    /**
     * Gets a single Nft Tracker with all of its associated Nft trackers.
     */
    async getNftTrackerId(requestParameters: GetNftTrackerIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftTrackerResponse> {
        const response = await this.getNftTrackerIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getNftTrackersRaw(requestParameters: GetNftTrackersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftTrackersResponse>> {
        const queryParameters: any = {};

        if (requestParameters['evmChain'] != null) {
            queryParameters['evmChain'] = requestParameters['evmChain'];
        }

        if (requestParameters['contractAddress'] != null) {
            queryParameters['contractAddress'] = requestParameters['contractAddress'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-trackers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNftTrackersResponseFromJSON(jsonValue));
    }

    /**
     */
    async getNftTrackers(requestParameters: GetNftTrackersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftTrackersResponse> {
        const response = await this.getNftTrackersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all the NFT trackers which belong to a grouping.
     */
    async getNftTrackersFromGroupingIdRaw(requestParameters: GetNftTrackersFromGroupingIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftTrackersFromGroupingResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getNftTrackersFromGroupingId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-trackers-from-grouping/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNftTrackersFromGroupingResponseFromJSON(jsonValue));
    }

    /**
     * Gets all the NFT trackers which belong to a grouping.
     */
    async getNftTrackersFromGroupingId(requestParameters: GetNftTrackersFromGroupingIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftTrackersFromGroupingResponse> {
        const response = await this.getNftTrackersFromGroupingIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a single NFT metadata for the specified ownership.
     */
    async getNftTrackersIdMetadataRaw(requestParameters: GetNftTrackersIdMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NftMetadata>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getNftTrackersIdMetadata().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/nft-trackers/{id}/metadata`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NftMetadataFromJSON(jsonValue));
    }

    /**
     * Gets a single NFT metadata for the specified ownership.
     */
    async getNftTrackersIdMetadata(requestParameters: GetNftTrackersIdMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NftMetadata> {
        const response = await this.getNftTrackersIdMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a single reward metadata for the specified tracker and all of its associated prizes.
     */
    async getNftTrackersIdRewardRaw(requestParameters: GetNftTrackersIdRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNftRewardResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getNftTrackersIdReward().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/nft-trackers/{id}/reward`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNftRewardResponseFromJSON(jsonValue));
    }

    /**
     * Gets a single reward metadata for the specified tracker and all of its associated prizes.
     */
    async getNftTrackersIdReward(requestParameters: GetNftTrackersIdRewardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNftRewardResponse> {
        const response = await this.getNftTrackersIdRewardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all redeemable NFT ownerships in user\'s Magic Wallet
     */
    async getRedeemableNftOwnershipsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserRedeemableNftOwnershipsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/redeemable-nft-ownerships`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserRedeemableNftOwnershipsResponseFromJSON(jsonValue));
    }

    /**
     * Get all redeemable NFT ownerships in user\'s Magic Wallet
     */
    async getRedeemableNftOwnerships(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserRedeemableNftOwnershipsResponse> {
        const response = await this.getRedeemableNftOwnershipsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Pre-burn validation so that users do not destroy their NFTs when there\'s no eligible prizes remaining.
     */
    async getValidateEligiblePrizesRemainingIdRaw(requestParameters: GetValidateEligiblePrizesRemainingIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getValidateEligiblePrizesRemainingId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/validate-eligible-prizes-remaining/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Pre-burn validation so that users do not destroy their NFTs when there\'s no eligible prizes remaining.
     */
    async getValidateEligiblePrizesRemainingId(requestParameters: GetValidateEligiblePrizesRemainingIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getValidateEligiblePrizesRemainingIdRaw(requestParameters, initOverrides);
    }

    /**
     * Update nft grouping in the system
     */
    async updateNftGroupingsRaw(requestParameters: UpdateNftGroupingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-groupings`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateNftGroupingBodyToJSON(requestParameters['updateNftGroupingBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update nft grouping in the system
     */
    async updateNftGroupings(requestParameters: UpdateNftGroupingsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateNftGroupingsRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a single NFT Grouping\'s associated NFT Trackers & Ownerships, then set it as disabled.
     */
    async updateNftGroupsIdRaw(requestParameters: UpdateNftGroupsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateNftGroupsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-groups/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a single NFT Grouping\'s associated NFT Trackers & Ownerships, then set it as disabled.
     */
    async updateNftGroupsId(requestParameters: UpdateNftGroupsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateNftGroupsIdRaw(requestParameters, initOverrides);
    }

    /**
     * Updates an existing NFT reward prize in the system for Admin.
     */
    async updateNftRewardPrizesIdRaw(requestParameters: UpdateNftRewardPrizesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateNftRewardPrizesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-reward-prizes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateNftRewardPrizeBodyToJSON(requestParameters['updateNftRewardPrizeBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates an existing NFT reward prize in the system for Admin.
     */
    async updateNftRewardPrizesId(requestParameters: UpdateNftRewardPrizesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateNftRewardPrizesIdRaw(requestParameters, initOverrides);
    }

    /**
     * Updates or Creates a NFT reward\'s metadata in the system and add prizes to the reward
     */
    async updateNftRewardsRaw(requestParameters: UpdateNftRewardsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-rewards`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertNftRewardBodyToJSON(requestParameters['upsertNftRewardBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates or Creates a NFT reward\'s metadata in the system and add prizes to the reward
     */
    async updateNftRewards(requestParameters: UpdateNftRewardsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateNftRewardsRaw(requestParameters, initOverrides);
    }

    /**
     * Updates a nft tracker in the system
     */
    async updateNftTrackersIdRaw(requestParameters: UpdateNftTrackersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateNftTrackersId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/nft-trackers/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddNftTrackerBodyToJSON(requestParameters['addNftTrackerBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates a nft tracker in the system
     */
    async updateNftTrackersId(requestParameters: UpdateNftTrackersIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateNftTrackersIdRaw(requestParameters, initOverrides);
    }

}
